import { Theme } from '@radix-ui/themes'
import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect, ConnectedProps } from 'react-redux'
import { updateSearchParams } from '@disco/state-management/actions/SearchActions'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import TagSelector from 'components/common/tag-selector'
import DocumentHeadTags from 'components/document-head-tags'
import { Flex } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import { overflownModalStyles } from 'components/utils/modalStyles'

const mapStateToProps = state => ({
  tags: state.search.tags,
})

const mapDispatchToProps = {
  updateSearchParams,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface OwnProps {
  navigate: NavigateFunction
}

type TagFilterProps = PropsFromRedux & OwnProps

class TagFilter extends Component<TagFilterProps> {
  _onClose = () => this.props.navigate('/')
  state = {
    selectedTags: this.props.tags,
  }
  _onTagsFilterChange = tags => {
    this.setState({
      selectedTags: tags.map(t => t.value),
    })
  }
  _handleFormSubmit = () => {
    this.props.updateSearchParams({
      tags: this.state.selectedTags,
    })

    this._onClose()
  }

  render() {
    return (
      <Modal onRequestClose={this._onClose} isOpen style={overflownModalStyles}>
        <Theme>
          <DocumentHeadTags title="Search | Filter by tags | DISCO" />
          <div className="Form">
            <h1 className="EditMetadata_Header">Search by Tags</h1>
            <div className="row">
              <div className="col-xs-12">
                <label className="Form_Label">Tags</label>
                <TagSelector
                  onChange={this._onTagsFilterChange}
                  selectedTags={this.state.selectedTags}
                  placeholder="Select tags"
                />
              </div>
            </div>
            <Flex justify="end">
              <ButtonContainer>
                <Button caption="Cancel" onClick={this._onClose} />
                <Button
                  caption="Update Search Filters"
                  onClick={this._handleFormSubmit}
                  appearance="primary"
                />
              </ButtonContainer>
            </Flex>
          </div>
        </Theme>
      </Modal>
    )
  }
}

const ConnectedTagFilter = connector(TagFilter)

function TagFilterWithRouter(props: any) {
  const navigate = useNavigate()
  return <ConnectedTagFilter {...props} navigate={navigate} />
}

export default TagFilterWithRouter
